import { DiscountTypes } from "@/common/enums";

export default class SquareSettingsModel {
    isEnabled: boolean = false;
    signatureKey: string = "";    
    accessToken: string = "";
    webhookUrl: string = "";
}
